import { Link } from "react-router-dom";
import { Bot, Route, Brain, ShieldCheck, MessageSquare, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHero } from "./Services";

export default function NexusAI() {
  return (
    <div>
      <PageHero label="Nexus AI" title="Meet Nexus — your 24/7 business assistant" subtitle="One friendly AI assistant that understands your needs and routes to the right specialist behind the scenes." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
        <div className="grid md:grid-cols-3 gap-5">
          {[[Route, "Smart routing", "Nexus identifies your intent and connects you with the right expertise — PC help, websites, automation, or scheduling."],
            [Brain, "Approved knowledge", "Answers come only from Thomason Digital Works' approved, up-to-date knowledge base and pricing."],
            [MessageSquare, "One conversation", "No repeating yourself. Nexus remembers context and asks one clear question at a time."],
            [Zap, "Instant help", "Available around the clock — get answers, request service, or book time without waiting."],
            [ShieldCheck, "Safe & honest", "Nexus never guarantees diagnoses, never asks for passwords, and always tells you when a human should step in."],
            [Bot, "Lead capture", "Ready to move forward? Nexus captures your details and hands off to our team seamlessly."]].map(([Ico, t, d], i) => (
            <div key={i} className="rounded-xl border border-slate-200 p-6">
              <div className="h-12 w-12 rounded-lg bg-gradient-to-br from-electric to-tech text-white grid place-items-center mb-4"><Ico className="h-6 w-6" /></div>
              <h3 className="font-heading font-semibold text-lg text-navy">{t}</h3>
              <p className="mt-2 text-sm text-slate-600">{d}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 rounded-2xl tdw-hero-gradient text-white p-10 text-center relative overflow-hidden">
          <div className="absolute inset-0 tdw-circuit opacity-40" />
          <div className="relative">
            <h3 className="font-heading text-2xl font-bold">Try Nexus now</h3>
            <p className="mt-2 text-slate-300">You're always told you're chatting with an AI assistant.</p>
            <Link to="/chat"><Button size="lg" className="mt-6 bg-electric hover:bg-tech gap-2" data-testid="nexus-try-btn"><Bot className="h-5 w-5" /> Start Chatting</Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
